<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            <i>"Clean teeth creates a clean smile for everyone"</i>
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class="uk-heading-line specHeading uk-text-center"><span>Dental Hygiene Clinic</span></h1>
        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <h3 class="uk-heading-bullet specHeading">Services Offered:</h3>
              <ul class="uk-list uk-list-bullet ">
                <li>Oral examination <i>(oral cancer screening included)</i></li>
                <li>Dental Prophylaxis <i>(cleaning)</i></li>
                <li>X-rays</li>
                <li>Fluoride treatment</li>
                <li>Sealants</li>
                <li>Fabrication of mouthguards/custom bleaching trays</li>
                <li>Counseling patients on proper toothbrushing, flossing, and good nutrition to maintain oral health</li>
              </ul>
            </div>
            <div>
              <img class="uk-align-center" src="../assets/d1.jpg" alt="">
            </div>
          </div>
          <div class="uk-child-width-1-1">
            <div>
              <p class="">
                <br><br>
                The students also participate in at least two (2) outreach projects per semester all over Jamaica to under-served areas.
                The department also offers free services at our annual in-reach projects where the services sometimes include extractions and fillings.
                Services are offered to Faculty, Staff, Students and the wider public. Services are offered at a reduced cost.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "dental",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Dental Hygiene Clinic',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Dental Hygiene Clinic at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
